export default {
      id: "ar_demarches-usage",
      viewBox: "0 0 68 50",
      url: "../dist/images/" + "sprite.svg#ar_demarches-usage",
      toString: function () {
        return this.url;
      }
    }